import React from 'react';
import './Header.css';

const Header = () => {
  return (
    <header className="app-header">
      <h1>今天又有什么好理由请假？</h1>
      <p>打工人专属请假理由生成器</p>
    </header>
  );
};

export default Header;
